import { SxProps, Theme } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';

export const TOP_BAR_HEIGHT = '72px';

export const TopBarStyles: SxProps<Theme> = {
  alignItems: 'center',
  backgroundColor: themeColors.white,
  boxSizing: 'border-box',
  color: themeColors.black,
  display: 'flex',
  flexShrink: 0,
  height: TOP_BAR_HEIGHT,
  justifyContent: 'space-between',
  position: 'sticky',
  px: { md: 3, xs: 1.5 },
  top: 0,
  width: '100%',
  zIndex: 500,
};

export const TopBarItemsStyles: SxProps<Theme> = {
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const TopBarProfileButtonStyles: SxProps<Theme> = {
  '&:active': {
    transform: 'scale(0.98)',
  },
  '&:focus-visible': {
    boxShadow: `0 0 0 3px ${themeColors.accentColor20}`,
  },
  '&:hover': {
    backgroundColor: themeColors.accentColor10,
    borderColor: themeColors.accentColorDark,
    color: themeColors.black,
  },
  '& .MuiButton-endIcon': {
    marginLeft: 0,
    marginRight: -0.5,
  },
  '& .MuiButton-startIcon': {
    marginLeft: -0.5,
    marginRight: 0.75,
  },
  border: `2px solid ${themeColors.accentColor}`,
  borderRadius: '999px',
  boxSizing: 'border-box',
  color: themeColors.black,
  maxWidth: { sm: 180, xs: 156 },
  minHeight: 38,
  minWidth: 0,
  overflow: 'hidden',
  px: 1.25,
  py: 0.25,
  whiteSpace: 'nowrap',
};

export const TopBarProfileAvatarStyles: SxProps<Theme> = {
  backgroundColor: themeColors.blueDark,
  border: `2px solid ${themeColors.white}`,
  boxShadow: `0 0 0 1px ${themeColors.accentColor20}`,
  color: themeColors.white,
  fontSize: 10,
  fontWeight: 700,
  height: 28,
  width: 28,
};

export const TopBarProfileNameStyles: SxProps<Theme> = {
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 1.2,
  maxWidth: { sm: 96, xs: 72 },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const TopBarProfileMenuListStyles: SxProps<Theme> = {
  p: 0,
};

export const TopBarProfileMenuPaperStyles: SxProps<Theme> = {
  border: `1px solid ${themeColors.stroke}`,
  borderRadius: '12px',
  boxShadow: '0 10px 28px rgba(23, 33, 43, 0.14)',
  mt: 1,
  overflow: 'hidden',
  width: 220,
};

export const TopBarProfileMenuHeaderStyles: SxProps<Theme> = {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  gap: 0.25,
  px: 1.75,
  py: 1,
};

export const TopBarProfileMenuNameStyles: SxProps<Theme> = {
  color: themeColors.black,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.3,
};

export const TopBarProfileMenuEmailStyles: SxProps<Theme> = {
  color: themeColors.greyDark,
  fontSize: 12.5,
  lineHeight: 1.35,
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const TopBarProfileRoleChipStyles: SxProps<Theme> = {
  '& .MuiChip-label': {
    px: 1,
  },
  alignSelf: 'flex-start',
  backgroundColor: themeColors.blueLight,
  borderRadius: '999px',
  color: themeColors.greyDark,
  fontSize: 11,
  fontWeight: 700,
  height: 24,
  mt: 0.5,
  textTransform: 'uppercase',
};

export const TopBarProfileMenuDividerStyles: SxProps<Theme> = {
  borderColor: themeColors.stroke,
  marginBottom: 0,
  marginTop: 0,
};

export const TopBarProfileMenuItemStyles: SxProps<Theme> = {
  '&:hover': {
    backgroundColor: themeColors.accentColor10,
  },
  borderRadius: '0 !important',
  color: themeColors.black,
  fontSize: 14,
  fontWeight: 600,
  minHeight: 40,
  px: 1.75,
  py: 0.75,
};
